<script>

export default {
    data: function () {
        return {
            postData: this.activeWidgets,
            widgetData: '',
        }
    },
    props: [
        'activeWidgets', 'homeApiUrl', 'newsUrl'
    ],
    computed: {
    },
    created() {
        },
    mounted() {
        this.getData();
    },
    watch: {
    },
    methods: {
        getData: function() {
            let postData = {
                categories: this.postData,
            };

            axios
                .post(this.homeApiUrl, postData)
                .then(response => {
                    this.widgetData = response.data;
                })
                .catch(error => {
                });
        },
    }

}
</script>
